// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1H4v_","col":"CardReaderDesc_col__13OXZ","label":"CardReaderDesc_label__2cjla"};